

























































import { defineComponent, computed } from "@vue/composition-api";
import { useVuex } from "@/hooks/use-vuex";

export default defineComponent({
  setup() {
    const {
      store: { state, commit, getters, dispatch }
    } = useVuex();

    const drawerOpen = computed({
      get: () => state.NavBar.drawerOpen,
      set: (value: boolean) => commit.NavBar.setDrawer({ value })
    });

    const notificationsActive = computed(
      () => getters.Notifications.notificationsActive
    );
    const notificationsHistory = computed(
      () => getters.Notifications.notificationsHistory
    );

    const notifications = computed(() => state.Notifications.notifications);
    const dismiss = commit.Notifications.dismiss;
    const dismissAll = dispatch.Notifications.dismissAll;
    const removeAll = dispatch.Notifications.removeAll;

    return {
      drawerOpen,
      notificationsActive,
      notificationsHistory,
      notifications,
      removeAll,
      dismissAll,
      dismiss
    };
  }
});
